export default "__VITE_ASSET__88514414__"